import { CommonInput } from './CommonInput';

export const TextAreaInput = ({
  id,
  label,
  placeholder,
  value,
  onChange,
  rows,

  labelWidth,
  column,
}: {
  id: string;
  label: string;
  placeholder?: string;
  value?: string;
  onChange: (value: string) => void;
  rows?: number;

  labelWidth?: number;
  column?: boolean;
}) => (
  <CommonInput $labelWidth={labelWidth} $column={column}>
    <label>{label}</label>
    <textarea
      id={id}
      placeholder={placeholder}
      value={value || ''}
      onChange={(e: any) => onChange(e.currentTarget.value)}
      rows={rows}
      spellCheck={false}
    />
  </CommonInput>
);
